import { Component, OnInit } from '@angular/core';
import { BaseTableService } from './base-tables/base-table.service';
import { SharedService } from 'app/services/core/shared.service';


@Component({
  selector: 'app-home',
  templateUrl: './calltrackerHome.component.html',
})

export class CalltrackerHomeComponent implements OnInit {

  constructor(public baseService: BaseTableService, public sharedService: SharedService) { }

  ngOnInit(): void {
    this.baseService.setup();
  }
}
